<template>
  <div class="bg-white min-height">
    <div class="made-l-grid--fixed full-height-page">
      <div class="made-l-grid">
        <div class="made-l-grid__row">
          <p>Health works!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "HealthPage",
  components: {},
});
</script>

<style lang="scss">
p {
  margin: 0;
}
.bg-white {
  background-color: #fff;
}
.min-height {
  min-height: calc(100vh);
}
</style>
